var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center font-2 price bold"},[_vm._v(" Total Puntos Crucero: "+_vm._s(_vm.totalPoints.toLocaleString('es-AR'))+" Pts ")])}
var staticRenderFns = []

export { render, staticRenderFns }